import { calculateDaysLeft } from "../../_shared/utils";

/**
 * Add daysLeft property to a scheduling item
 * @param item - Scheduling item
 * @returns Scheduling item with daysLeft
 */
export const addDaysLeftToScheduling = <T extends App.Scheduling>(item: T): T & { daysLeft: number } => ({
  ...item,
  daysLeft: calculateDaysLeft(item.expirationDate)
});
